import { render } from "./Show.vue?vue&type=template&id=77b2ef6c"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"
script.render = render

export default script